import React, {useEffect, useRef} from "react";
import {Box, Button, Container, Typography} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {Link} from "react-router-dom";
import {colors} from "../../styling/GlobalTheme";
import Countdown from "./Countdown";
import {dateRange} from "./format";
import useFeaturedRace from "./useFeaturedRace";

/* Grand bandeau d'accueil : course mise en avant + compte à rebours */
export default function Hero() {
    const race = useFeaturedRace();
    const bg = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const onScroll = () => {
            if (bg.current && window.scrollY < window.innerHeight)
                bg.current.style.transform = `translateY(${window.scrollY * 0.3}px) scale(1.05)`;
        };
        window.addEventListener("scroll", onScroll, {passive: true});
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <Box component="section" sx={{position: "relative", minHeight: {xs: "100svh", md: "100vh"}, display: "flex", alignItems: "center", color: "#fff", overflow: "hidden", bgcolor: colors.night}}>
            <Box ref={bg} sx={{
                position: "absolute", inset: "-5% 0", backgroundImage: `url("${race.image}")`, backgroundSize: "cover",
                backgroundPosition: {xs: "65% center", md: "center 35%"}, transform: "scale(1.05)", willChange: "transform",
            }}/>
            <Box sx={{position: "absolute", inset: 0, background: {
                xs: "linear-gradient(180deg, rgba(11,18,32,.55) 0%, rgba(11,18,32,.55) 50%, rgba(11,18,32,.9) 100%)",
                md: "linear-gradient(90deg, rgba(11,18,32,.88) 0%, rgba(11,18,32,.55) 45%, rgba(11,18,32,0) 75%)",
            }}}/>
            <Container maxWidth="lg" sx={{position: "relative", pt: {xs: 12, md: 10}, pb: 10, textAlign: {xs: "center", md: "left"}}}>
                <Box sx={{maxWidth: 680, mx: {xs: "auto", md: 0}, animation: "mp-fadeup 1s ease both"}}>
                    <Box sx={{display: "inline-flex", alignItems: "center", gap: 1, bgcolor: colors.red, px: 2, py: .7, borderRadius: 99, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", fontSize: ".8rem"}}>
                        {dateRange(race.start, race.end)}
                    </Box>
                    <Typography variant="h1" sx={{fontSize: {xs: "3.6rem", sm: "5rem", md: "7rem"}, mt: 2.5, mb: 1}}>
                        {race.title}
                    </Typography>
                    <Typography sx={{fontSize: {xs: "1.05rem", md: "1.35rem"}, opacity: .92}}>
                        {race.subtitle}{race.place ? ` · ${race.place}` : ""}
                    </Typography>
                    <Countdown target={race.start}/>
                    <Box sx={{display: "flex", gap: 1.5, flexWrap: "wrap", justifyContent: {xs: "center", md: "flex-start"}}}>
                        <Button size="large" variant="contained" href={race.link} target="_blank" rel="noopener" endIcon={<ArrowOutwardIcon/>}
                                sx={{bgcolor: colors.red, color: "#fff", "&:hover": {bgcolor: "#c92f3b", transform: "translateY(-2px)"}, transition: ".25s"}}>
                            Infos officielles FIS
                        </Button>
                        <Button size="large" variant="outlined" component={Link} to="/course"
                                sx={{color: "#fff", borderColor: "#fff", borderWidth: 2, "&:hover": {bgcolor: "#fff", color: colors.night, borderWidth: 2}}}>
                            Découvrir la course
                        </Button>
                    </Box>
                </Box>
            </Container>
            <Box component="a" href="#prochainement" aria-label="Défiler" sx={{position: "absolute", bottom: 20, left: "50%", color: "#fff", animation: "mp-bounce 2s infinite"}}>
                <KeyboardArrowDownIcon fontSize="large"/>
            </Box>
        </Box>
    );
}
